import setCookie from "~/kernel/cookies/setCookie";
import ANALYTICS_COOKIES from "../models/ANALYTICS_COOKIES";
import getAnalyticsSessionId from "./getAnalyticsSessionId";

export default function storeAnalyticsMetadataInCookie() {
  setCookie(ANALYTICS_COOKIES.SessionId, getAnalyticsSessionId());
  setCookie(ANALYTICS_COOKIES.ScreenWidth, String(window.screen.width));
  setCookie(ANALYTICS_COOKIES.ScreenHeight, String(window.screen.height));
}
